import { render, staticRenderFns } from "./TheSocialLinks.vue?vue&type=template&id=55a6aab4"
import script from "./TheSocialLinks.vue?vue&type=script&lang=js"
export * from "./TheSocialLinks.vue?vue&type=script&lang=js"
import style0 from "./TheSocialLinks.vue?vue&type=style&index=0&id=55a6aab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports